import React from 'react';
import {
    Box,
    Typography,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    FormControlLabel,
    Checkbox
    } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import NotificationsIcono from '@material-ui/icons/NotificationsActiveOutlined';


export function TextoBienestar({ contenido = {}, onChange, fieldName, aceptado }) {
    const colorTitulo = '#d32f2f';

    const handleCheckboxChange = (e) => {
        if (onChange && fieldName) {
            onChange({
                target: {
                    name: fieldName,
                    value: e.target.checked
                }
            });
        }
    };

    return (
        <Box>
            <Accordion defaultExpanded={false} style={{ border: '1px solid #e0e0e0' }}>
                <AccordionSummary expandIcon={<ExpandMoreIcon />} style={{ paddingTop: '12px', paddingBottom: '12px' }}>
                    <Box display="flex" alignItems="center" width="100%" justifyContent="space-between">
                        <Box display="flex" alignItems="center" gridGap={8}>
                            <NotificationsIcono style={{ color: colorTitulo }} fontSize="small" />
                            <Typography variant="subtitle2" style={{ fontWeight: '600', color: colorTitulo }}>
                                {contenido.titulo}
                            </Typography>
                        </Box>
                        <Typography variant="caption" style={{ color: '#666' }}>Ver más</Typography>
                    </Box>
                </AccordionSummary>
                <AccordionDetails
                    style={{ display: 'block', padding: '16px', maxHeight: '350px', overflowY: 'auto', backgroundColor: '#fafafa' }}
                    >
                    {(() => {
                        const texto = contenido.descripcion || "";
                        let bloques = texto.split('·').map(t => t.trim()).filter(Boolean);
                        let elementos = [];
                        bloques.forEach(bloque => {
                        if (/^[A-ZÁÉÍÓÚÑ\s]{6,}$/.test(bloque)) {
                            elementos.push({ tipo: 'titulo', texto: bloque });
                        } else {
                            const oraciones = bloque.split(/(?<=\.)\s+(?=[A-ZÁÉÍÓÚÑ])/g);
                            oraciones.forEach(o => elementos.push({ tipo: 'texto', texto: o.trim() }));
                        }
                        });

                        return elementos.map((item, idx) => {
                        if (item.tipo === 'titulo') {
                            return (
                            <Typography
                                key={idx}
                                variant="subtitle2"
                                style={{ fontWeight: 600, marginTop: 12, marginBottom: 6 }}
                            >
                                {item.texto}
                            </Typography>
                            );
                        }

                        return (
                            <Typography
                            key={idx}
                            variant="body2"
                            style={{
                                textAlign: 'justify',
                                marginBottom: 10,
                                color: '#555',
                                fontSize: '0.875rem'
                            }}
                            >
                            {item.texto}
                            </Typography>
                        );
                        });
                    })()}

                    <Typography
                        variant="caption"
                        style={{ fontWeight: '500', fontStyle: 'italic', marginTop: '12px', color: '#666', display: 'block', marginBottom: '16px' }}
                    >
                        Leído y comprendido el presente documento, declaro que acepto de manera libre, consciente y voluntaria las condiciones aquí establecidas, sin mediar presión alguna. En consecuencia, otorgo mi consentimiento y me comprometo a cumplir con las disposiciones y compromisos señalados en el presente documento.
                    </Typography>

                    {fieldName && (
                        <FormControlLabel
                        control={
                        <Checkbox
                        checked={!!aceptado}
                        onChange={handleCheckboxChange}
                        name={fieldName}
                        color="primary"
                        size="small"
                        />
                        }
                        label={<Typography variant="caption" style={{ color: '#666' }}>Acepto los términos y condiciones</Typography>}
                        />
                    )}
                    </AccordionDetails>
            </Accordion>
        </Box>
    );
}


export const ProteccionDatos = ({ texto, aceptacion, value, onChange, name = "acepta_proteccion_datos" }) => {
    if (!texto && !aceptacion) return null;

    const handleCheckboxChange = (e) => {
        // Llama a onChange con el valor booleano
        // El padre puede envolverlo si necesita un evento completo
        onChange(e.target.checked);
    };

    return (
        <Box style={{
            backgroundColor: "#f5f5f5",
            padding: "16px",
            borderRadius: "8px",
            marginTop: "16px"
        }}>
        <Typography
            variant="body2"
            style={{
            textAlign: 'justify',
            whiteSpace: 'pre-line',
            marginBottom: '12px',
            color: '#555',
            fontSize: '0.875rem'
            }}
        >
            <strong>Protección de datos:</strong> {texto}
        </Typography>

        {aceptacion && (
            <Typography
            variant="caption"
            style={{
                fontWeight: '500',
                fontStyle: 'italic',
                marginTop: '12px',
                color: '#3a3939ff',
                display: 'block',
                marginBottom: '16px'
            }}
            >
            {aceptacion}
            </Typography>
        )}

        <FormControlLabel
            control={
            <Checkbox
                checked={!!value}
                onChange={handleCheckboxChange}
                name={name}
                color="primary"
                size="small"
            />
            }
            label={
            <Typography variant="caption" style={{ color:'#3a3939ff', fontWeight: '500' }}>
                <strong>Acepto los términos y condiciones*</strong>
            </Typography>
            }
        />
        </Box>
    );
    };
